/** Parse LEPC jurisdiction "STATE_lepcId" into { state, lepcId }. */
export function parseLepcJurisdiction(
  jurisdiction: string | null | undefined
): {
  state: string;
  lepcId: string;
} | null {
  if (!jurisdiction || !jurisdiction.includes("_")) return null;
  const idx = jurisdiction.indexOf("_");
  const state = jurisdiction.slice(0, idx).trim();
  const lepcId = jurisdiction.slice(idx + 1).trim();
  return state && lepcId ? { state, lepcId } : null;
}
